<ng-container *ngIf="isUser == 1">
  <app-subadmin-header></app-subadmin-header>
</ng-container>
<ng-container *ngIf="isUser == 0">
  <app-home-header></app-home-header>
</ng-container>
 <section class="work">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
        <div class="all_model">
					<div class="all_model1">
					  <span class="backk"> <a [routerLink]="['/admin/home']"><img loading="lazy" src="../../../../assets/images/backcu.png" style="height: 40px;">
					  </a></span>
					</div>
					<h5>Home / Scheduling</h5>
		  
				  </div>
			    <!-- <div class="search_done">
				   <span class="backk"> <a [routerLink]="['/home']"><img loading="lazy" src="../../../../assets/images/backcu.png" style="height: 40px;"></a> </span>
			    </div> -->
			</div>
	</div>
	</div>
</section>
<!--- end of work section----->
<section class="work" style="padding: 30px 0 43px;">
  <div class="container">
<div class="row mb-4">
  <div class="col-md-6 col-6">
    <div class="btn-group">
      <div
        class="btn calandar"
        mwlCalendarPreviousView
        [view]="view"
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
      >
        Previous
      </div>
      <div
        class="btn btn-outline-secondary"
        mwlCalendarToday
        [(viewDate)]="viewDate"
      >
        Today
      </div>
      <div
        class="btn calandar"
        mwlCalendarNextView
        [view]="view"
        [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()"
      >
        Next
      </div>
    </div>
  </div>
  <div class="col-md-6 col-6 text-right">
    <h3 class="cal_title">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
  </div>
</div>
  <div>
  <mwl-calendar-month-view
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [activeDayIsOpen]="activeDayIsOpen"
    (dayClicked)="dayClicked($event.day)"
  >
  </mwl-calendar-month-view>
  </div>

<div class="events_sec">
<h3> Events </h3>
 <div class="">
   <h5>Selected Date : <span> {{dateSel}} </span> </h5>
   <h5 *ngFor="let admn of adminEventData"> Admin Name  :<span>{{admn.title}}</span></h5>
 </div>
</div>

  </div>
</section>

<section class="process_invoice">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="times">
					<ul>
						<li *ngFor="let slt of timeSlots">
							 <div class="form-check">
							 <input class="form-check-input" (change)="onChangeAdmin($event.target.checked,slt)" type="checkbox" id="{{slt.slots}}" value="option1">
							 <label [ngClass]="{'active': slt.active}" class="form-check-label" for="{{slt.slots}}">
								<a>{{slt.slots}}</a>
              </label>
							 </div>
							<div class="time_box">
								<p class="" *ngFor="let nme of slt.slotTimes"> {{nme.userName}}<span class="dot_black" *ngIf="nme.isCompleted == 1"></span><span *ngIf="nme.isCancelled == 1" class="dot_red"></span></p>
							</div>
              </li>
					</ul>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-9">
				<div class="times_sub">
					<h4 class="mb-3"> Sub Admin </h4>
          <ng-container *ngFor="let admn of admins">
					<button class="mr-2" (click)="selectAdmin(admn.id)" [ngClass]="{'active':admn.id == selectedAdmin}"> {{admn.userName}} </button>
          </ng-container>
				</div>

				<div class="sub_admin_new_det">
					<div class="row child_row">
						<div class="col-md-6" *ngFor="let rcp of receipts">
              <div class="scheBack">
							<div class="sub_a_admin">
								<div class="detail_new_sub_main" *ngFor="let data of rcp.slots">
									<div class="detail_new_sub_left">
										<h6> <b> {{rcp.userName}} </b></h6>
										<p> {{data.custName}}/{{data.details}}/{{data.timeRange}}</p>
									</div>
									<div class="detail_new_sub_right" *ngIf="isUser == 1">
										<button (click)="onStatus(data.id,'1')" class="mr-2"> Add as member </button>
										<!-- <button *ngIf="data.isComplete != 1 && data.isCancelled != 1" (click)="onStatus(data.id,'2')" class="mr-2"> Complete </button> -->
                    <button *ngIf="data.isComplete != 1 && data.isCancelled != 1" (click)="showRcpt(imageReciept,data)" class="mr-2"> Complete </button>
										<button *ngIf="data.isCancelled != 1 && data.isComplete != 1" (click)="onStatus(data.id,'3')" class="mr-2"> Cancelled </button>
										<button (click)="onStatus(data.id,'4')" class="mr-2"> Feedback </button>
									</div>
								</div>
							</div>
						</div>
            </div>
					</div>
				</div>
			</div>

			<div class="col-md-3">
				<div class="customer_form">
				  <form [formGroup]="scheduleP" (ngSubmit)="scheduleSubmit()">
					<div class="customer_input">
					   <label>  Customer Number  </label>
						<input formControlName="custNum" (keyup)="onKeyUp($event)"  type="text" placeholder="" class="form-control">
            <!-- <span class="tick_input"> <a (click)="checkIfUser()"><i class="fas fa-check"></i> </a></span> -->
					</div>
           <ng-container *ngIf="submitted && scheduleIn.custNum.errors">
              <p class="error-message" *ngIf=" scheduleIn.custNum.errors.required" style="font-size: 12px;">
                  Customer Number is required!
              </p>
            </ng-container>
					<div class="customer_input">
					   <label>  Customer Name  </label>
						<input formControlName="custName" type="text" placeholder="" class="form-control">

             <ng-container *ngIf="submitted && scheduleIn.custName.errors">
              <p style="font-size: 12px;" class="error-message" *ngIf=" scheduleIn.custName.errors.required">
                  Customer Name is required!
              </p>
            </ng-container>
					</div>
					<div class="customer_input">
					   <label>  Selected Date  </label>
						<input formControlName="time" readonly type="text" placeholder="" class="form-control">
             <ng-container *ngIf="submitted && scheduleIn.time.errors">
              <p style="font-size: 12px;" class="error-message" *ngIf=" scheduleIn.time.errors.required">
                 Please select any date from calendar
              </p>
            </ng-container>
					</div>
					<div class="customer_input">
					   <label>  Details  </label>
						<textarea formControlName="detail" class="form-control" rows="3" placeholder="Write note here..."></textarea>
            <ng-container *ngIf="submitted && scheduleIn.detail.errors">
              <p style="font-size: 12px;" class="error-message" *ngIf=" scheduleIn.detail.errors.required">
                  Detail is required!
              </p>
            </ng-container>
					</div>
					<div class="right_side_admin_input text-center">
						<button> Save </button> <a (click)="cancelData()"> Cancel </a>
					</div>
				  </form>



				</div>
			</div>
		</div>

	</div>
</section>

<section class="Receipt gray_baack subb-admin">
	<div class="container">
	   <h2 class="title text-center"> Sub admins </h2>
		<div class="row mt-4 pt-4">

		 		<div class="col-md-6 mb-4" *ngFor="let act of actions">
				    <div class="Sub_admins_on">
						<div class="Sub_admins">
							<div class="media position-relative sub_image" *ngFor="let at of act.actions">
							  <img loading="lazy" src="{{imageUrl}}{{act.image}}" class="mr-3" alt="..." (error)="onImgError($event)">
							  <div class="media-body">
								<h5 class="">{{act.userName}} <span>{{at.created*1000 | date : 'fullDate'}}</span></h5>
								<p>{{at.action}}</p>
							  </div>
							</div>
						</div>
				    </div>
				</div>
	</div>
	</div>
</section>


 <!-- <app-home-bottom-banner></app-home-bottom-banner> -->
 <app-home-footer></app-home-footer>



  <ng-template #imageReciept let-modal>
		<div id="Receipt_modal" class="login_me" role="dialog">
        <!-- <div class="modal-dialog"> -->
          <!-- Modal content-->
          <div class="modal-content">
            <button type="button" style="outline: none;" (click)="modal.dismiss('Cross click')" class="close close_modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span> </button>
            <div class="modal-header">
              <h4 class="modal-title"> Save Receipt </h4>
            </div>
            <div class="modal-body">
                  <form class=" recipt_form">
                      <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <img loading="lazy" [src]="recieptImage">
                      <input type="file" class="form-control rec_img_up" nbInput fullWidth #file capture="camera" accept="image/*" id="cameraInput" name="cameraInput" (change)="onFileSelected(file.files)">
                      <!-- <button type="button" (click)="onUpload()">Upload File</button> -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input type="text" [(ngModel)]="keydetail" [ngModelOptions]="{standalone: true}"  class="form-control" id="email" placeholder="add detail">
                    </div>
                    </div>

                      <div class="col-md-12">
                    <div class="form-group">
                      <input type="text" [(ngModel)]="keyValue" [ngModelOptions]="{standalone: true}"  class="form-control" id="email" placeholder="add key reciept value">
                    </div>
                    </div>
                    <div class="col-md-12">
                    <div class="form-group">
                      <input type="text" class="form-control" id="pwd"  readonly value="{{phone}}">
                    </div>
                    </div>

                    <div class="col-md-12">
                        <a class="sign_in" (click)="onUpload()"> Save </a>
                   </div>
                   </div>
                  </form>
            </div>
          </div>
        <!-- </div> -->
      </div>
	  </ng-template>
